import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import handleRequestError from '../../utils/handleRequestError';

const initialState = {
    isLoading: true,
    allWaterConsumption: [],
    waterConsumptionById: [],
    filters: {
        startdate: null,
        enddate: null,
        locationid: '',
    },
    error: '',
};

export const fetchConsumptionWater = createAsyncThunk(
    'consumptionWater/fetchConsumptionWater',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/water`, {
                params,
            });

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const fetchConsumptionWaterById = createAsyncThunk(
    'consumptionWater/fetchConsumptionWaterById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/water/${id}`);

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const createConsumptionWater = createAsyncThunk(
    'hrStaff/createConsumptionWater',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_HOST_API_KEY}/water`, data);

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const updateConsumptionWater = createAsyncThunk(
    'hrStaff/updateConsumptionWater',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_HOST_API_KEY}/water`, data);

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

export const deleteConsumptionWater = createAsyncThunk(
    'hrStaff/deleteConsumptionWater',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_HOST_API_KEY}/water`, {
                data
            });

            return response.data;
        } catch (err) {
            return handleRequestError(err, rejectWithValue);
        }
    }
);

const consumptionWaterSlice = createSlice({
    name: 'consumptionWaterSlice',
    initialState,
    reducers: {
        setFilters(state, action) {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters(state) {
            state.filters = {
                ...state.filters,
                locationid: '',
            };
        },
    },
    extraReducers(builder) {
        builder.addCase(fetchConsumptionWater.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchConsumptionWater.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.allWaterConsumption = payload.data;
        });
        builder.addCase(fetchConsumptionWater.rejected, (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        });
        builder.addCase(fetchConsumptionWaterById.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchConsumptionWaterById.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.error = '';
            state.waterConsumptionById = payload.data;
        });
        builder.addCase(fetchConsumptionWaterById.rejected, (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        });
        builder.addCase(createConsumptionWater.fulfilled, (state) => {
            state.isLoading = false;
            state.error = '';
        });
        builder.addCase(createConsumptionWater.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(createConsumptionWater.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(updateConsumptionWater.fulfilled, (state) => {
            state.isLoading = false;
            state.error = '';
        });
        builder.addCase(updateConsumptionWater.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(updateConsumptionWater.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        builder.addCase(deleteConsumptionWater.fulfilled, (state) => {
            state.isLoading = false;
            state.filters = { ...state.filters };
            state.error = '';
        });
        builder.addCase(deleteConsumptionWater.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(deleteConsumptionWater.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});

export const { setFilters, resetFilters } = consumptionWaterSlice.actions;

export default consumptionWaterSlice.reducer;

export const selectConsumptionWaterFilters = (state) => state.consumptionWater.filters;
export const selectConsumptionWaterData = (state) => state.consumptionWater.allWaterConsumption;
export const selectConsumptionWaterDataById = (state) => state.consumptionWater.waterConsumptionById;
export const selectConsumptionWaterLoading = (state) => state.consumptionWater.isLoading;
export const selectConsumptionWaterError = (state) => state.consumptionWater.error;
